import { Box, Button, Group } from "@mantine/core";
import { useProject } from "../../../hooks/useProject";

export interface StructureViewButtonsProps {
  projectId: string;
  openModal: (arg?: { isV2: boolean }) => void;
  isPartialFeedin: boolean;
  shouldShowStaffView: boolean;
}

function StructureViewButtons({
  projectId,
  openModal,
  isPartialFeedin,
  shouldShowStaffView
}: StructureViewButtonsProps) {
  const { project } = useProject(projectId);
  const showMBKWithVersioningButton =
    (project?.customerMbkWriteAccessActive && isPartialFeedin) ||
    shouldShowStaffView;

  if (!showMBKWithVersioningButton) {
    return null;
  }

  return (
    <Box className="StructureViewButtons" mb="xl">
      <Group
        gap="xs"
        justify="center"
        maw={{ base: undefined, lg: 780 }}
        mx={{ base: undefined, lg: "auto" }}
      >
        <Button
          autoContrast
          color="warning"
          size="md"
          w={{ base: "100%", sm: "49%" }}
          onClick={() => openModal({ isV2: true })}
        >
          Mess- und Bilanzierungskonzept
          <br />
          mit zeitlicher Veränderbarkeit
        </Button>
      </Group>
    </Box>
  );
}

export { StructureViewButtons };
